import { z } from "zod";

export const roleResponseSchema = z.object({
  name: z.string(),
  description: z.string(),
  status: z.enum(["ACTIVE", "INACTIVE"]),
  type: z.enum(["OOTB", "CUSTOM"]),
  permissions: z.array(z.string()),
  immutable: z.boolean().optional(),
  lastUpdated: z.string(),
  lastUpdatedBy: z.string().nullable(),
  roleKey: z.string(),
  roleName: z.string(),
});

export type RoleResponse = z.infer<typeof roleResponseSchema>;

export const userRoleAndPermissionSchema = z.object({
  userId: z.string(),
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
  lastUpdated: z.number(),
});

export type UserRoleAndPermissionResponse = z.infer<
  typeof userRoleAndPermissionSchema
>;
